//#region IMPORTS
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  clearFilterHandler: (name: string) => void;
  disabled?: boolean;
  value: string;
  hide?: boolean;
  name: string;
}
//#endregion

export default function MainFilterBarFilteredListItem({
  clearFilterHandler,
  disabled = false,
  value,
  hide = false,
  name,
}: Props) {
  //#region RENDER
  return !hide ? (
    <Fragment>
      <span
        data-tooltip-id={value + name + "3c71e2b7-368c-45f0-b1b5-6db340954ea7"}
        data-tooltip-variant={disabled ? "error" : "dark"}
        data-tooltip-content={`${disabled ? "Fixed filter " : ""}${name.replace(
          /_/g,
          " "
        )}`}
        key={name}
        className={classNames(
          disabled
            ? "justify-center bg-white text-slate-500"
            : "bg-slate-100 text-slate-600",
          "inline-flex items-center gap-x-0.5 rounded-md px-2 py-1 text-xs font-medium text-slate-600 ring-1 ring-inset ring-slate-500/20"
        )}
      >
        {value === "false"
          ? "non-active only"
          : value === "true"
          ? "active only"
          : name === "exclude_order_type"
          ? "Opening / Re-opening"
          : value}
        {!disabled ? (
          <button
            type="button"
            onClick={() => clearFilterHandler(name)}
            disabled={disabled}
            className="group relative -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-gray-500/20"
          >
            <svg
              viewBox="0 0 14 14"
              className="h-3.5 w-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75"
            >
              <path d="M4 4l6 6m0-6l-6 6" />
            </svg>
            <span className="absolute -inset-1" />
          </button>
        ) : null}
      </span>
      <Tooltip id={value + name + "3c71e2b7-368c-45f0-b1b5-6db340954ea7"} />
    </Fragment>
  ) : null;
  //#endregion
}
